import SvgIcon from "src/components/shared/SvgIcon";

const IconRefresh = (props: any) => {
  const size = props?.size || 12;
  return (
    <SvgIcon>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 640 640"
        width={size}
        height={size}
        {...props}
      >
        {/* <!--!Font Awesome Pro v7.3.1 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2026 Fonticons, Inc.--> */}
        <path d="M173 172.9C254.2 91.7 385.9 91.7 467.2 172.9L494.3 200L416.1 200C402.8 200 392.1 210.7 392.1 224C392.1 237.3 402.8 248 416.1 248L552.2 248C565.5 248 576.2 237.3 576.2 224L576.2 88C576.2 74.7 565.5 64 552.2 64C538.9 64 528.2 74.7 528.2 88L528.2 166.1L501.1 139C401.1 39 239 39 139.1 139C95.9 182.2 71.3 237.1 65.5 293.5C64.1 306.7 73.7 318.5 86.9 319.8C100.1 321.1 111.9 311.6 113.2 298.4C118 252.6 137.9 208.1 173 172.9zM574.7 346.5C576.1 333.3 566.5 321.5 553.3 320.2C540.1 318.9 528.3 328.4 527 341.6C522.3 387.4 502.3 432 467.2 467.1C386 548.3 254.3 548.3 173 467.1L145.9 440L224.1 440C237.4 440 248.1 429.3 248.1 416C248.1 402.7 237.4 392 224.1 392L88 392C74.7 392 64 402.7 64 416L64 552C64 565.3 74.7 576 88 576C101.3 576 112 565.3 112 552L112 473.9L139.1 501C239.1 601 401.2 601 501.1 501C544.3 457.8 568.9 402.9 574.7 346.5z" />
      </svg>
    </SvgIcon>
  );
};

export default IconRefresh;
